import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Payment from "./pages/Payment";
import dotenv from "dotenv";
import Identification from "./pages/Identification";
import Verification from "./pages/Verification";

dotenv.config();

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/id" element={<Identification />} />
        <Route path="/verif" element={<Verification />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
